<template>
    <div style="min-height: 400px;  height: auto;">
        <div class="head-title">
            <!-- 所属题库 -->
            <div class="head-title-in-1">
                <div style="display: flex; float: left; padding-top: 2px; align-items: center; margin-bottom: 5px;">
                    <div style="width: 80px; font-size:15px">
                        <span style="font-weight: 600;">所属题库：</span>
                    </div>
                    <el-radio-group v-model="pbfrom">
                        <el-radio-button label="1">总题库</el-radio-button>
                        <el-radio-button label="2">入门与面试</el-radio-button>
                        <el-radio-button label="3">CodeForces</el-radio-button>
                        <el-radio-button label="4">AtCoder</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <!-- 筛选条件 -->
            <div class="head-title-in-2"> 
                <div style="display: flex; float: left;">
                    <div style="width: 67px; font-size:15px">筛选条件</div>
                    <!-- 算法标签选择 -->
                    <div style="font-size:16px; margin-left:10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
                        <el-button plain style="color:#BFC3CB;" @click="ClickMeToOpen">算法标签选择</el-button>

                        <el-dialog 
                        top='50px'
                        title="算法标签"
                        :visible.sync="dialogVisible"
                        width="60%" style="height: auto; overflow: hidden;">
                        
                        <div style="height: 380px; overflow: auto;">

                        <el-tag style="font-size:16px;" type="danger">语言入门</el-tag>
                        <el-checkbox-group v-model="select" fill="#409EFF" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag1" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                        
                        <el-tag style="font-size:16px;" >基础算法</el-tag>
                        <el-checkbox-group v-model="select" fill="#409EFF" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag0" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                    
                        <el-tag style="font-size:16px;" type="success">字符串</el-tag>
                        <el-checkbox-group v-model="select" fill="#67C23A" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag2" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                        
                    
                        <el-tag style="font-size:16px;" type="info">动态规划</el-tag>
                        <el-checkbox-group v-model="select" fill="#909399" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag3" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                        
                    
                        <el-tag style="font-size:16px;" type="warning">搜索</el-tag>
                        <el-checkbox-group v-model="select" fill="#E6A23C" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag4" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                        
                    
                        <el-tag style="font-size:16px;" type="danger">数学</el-tag>
                        <el-checkbox-group v-model="select" fill="#F56C6C" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag5" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>

                        <el-tag style="font-size:16px;">图论</el-tag>
                        <el-checkbox-group v-model="select" fill="#F56C6C" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag6" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>

                        <el-tag style="font-size:16px;" type="success">计算几何</el-tag>
                        <el-checkbox-group v-model="select" fill="#F56C6C" text-color="#FFFFFF" style="padding-top: 10px;">
                        <el-checkbox-button style="margin: 4px ; border: 1px solid lightgrey; border-radius: 4px;" v-for="city in tag7" :label="city" :key="city">{{city}}</el-checkbox-button>
                        </el-checkbox-group>
                        </div>

                        

                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="ClickMeToSelect">确 定</el-button>
                        </span>
                        </el-dialog>
                    </div>
                    <!-- 难度选择 -->
                    <div style="width:180px; font-size:16px; margin-left:10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
                        <el-select clearable v-model="value" placeholder="难度选择">
                            <el-option
                            v-for="item in Difficulity"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- 直接按名字或者题号搜索 -->
                    <div style="font-size:16px; margin-left:30px; display: flex; justify-content: center; align-content: center;" >
                        <el-input
                        clearable
                        placeholder="题号 / 题目名称"
                        prefix-icon="el-icon-search"
                        v-model="input"
                        @keyup.native.enter="ClickMeToSearch">
                        </el-input>
                    </div>
                </div>
            </div>
            <!-- 已经选择了什么 -->
            <div style="padding-top: 10px; clear: both; min-height: 20px; height: auto; font-size: 14px;">
                <div style="font-size: 16px; font-weight: 600;">已选择：</div>
                <div style="padding: 10px; font-size: 14px;">
                    <el-tag
                        v-for="(item,index) in select"
                        :key="index"
                        type='info'
                        effect="dark"
                         style="margin: 5px;">
                        {{ item }}
                        <!-- <el-button icon= size="mini" style="height: 10px;"></el-button> -->
                        <i class="el-icon-close" @click="ClickMeBySelect(item)"></i>
                    </el-tag>
                </div>
            </div>
            <!-- 有多少条记录 -->
            <div class="head-title-in-3">
                <div style="height: auto; width: 100%; display: flex; float: left;">
                    <div style="width: 80%; font-size:16px; color: rgba(0,0,0,.45);">共计{{ this.$store.state.problem.question.length }}条结果</div>
                    <div style="width: 20%; font-size:16px; color: #3C9CDC;" @click="ClickMeToClear">清除所有筛选条件</div>
                </div>
            </div>
        </div>

        <div class="body">
            <table class="table table-striped table-hover" v-loading="loading">
                <thead>
                    <tr style="font-size: 14px;">
                        <th scope="col-2">题号</th>
                        <th scope="col-2">标题</th>
                        <th scope="col-6"> 
                            <el-switch
                            v-model="IsVis"
                            active-text="显示"
                            inactive-text="隐藏">
                            </el-switch>
                        </th>
                        <th scope="col-2">难度</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="t in showpage" :key="t.pbid">
                        <th class="col-2" style="font-size: 13px;" @click="ClickMeGoproblem(t)">{{ t.pbid }}</th>
                        <td class="col-2" style="font-size: 13px;" @click="ClickMeGoproblem(t)">{{ t.name }}</td>
                        <td class="col-6" style="font-size: 13px;">
                            <span v-show="IsVis">
                                <span v-show="t.Basic !== ''">
                                    {{ t.altag }}
                                </span>
                                <span v-show="t.Basic === ''">
                                    无
                                </span>
                            </span>
                        </td>
                        <td class="col-2" style="font-size: 13px;">{{ t.difficulty }}</td>
                    </tr>
                </tbody>
            </table>

            <!-- 分页设置 -->
            <div class="block">
                <span class="demonstration">直接前往</span> 
                <!-- :page-size="100" 表示一页100条消息，上限1000条 所以说想自定义上限可以 ==> 想要的页数k  :page-size="(1000 + k - 1) / k"-->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage3"
                :page-size="pageSize" 
                layout="prev, pager, next, jumper"
                :total="1000">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    const tag0 = ['排序', '贪心', '二分', '高精度', '前缀和', '双指针', '位运算', '离散化', '区间合并']
    const tag1 = ['语言入门', '顺序结构', '分支结构', '循环结构', '数组', '字符串(入门)', '结构体', '函数与递归'];
    const tag2 = ['字符串', '后缀自动机', '字典树', 'AC自动机', 'KMP', '后缀数组', '后缀树'];
    const tag3 = ['DP', '背包问题', '线性DP', '区间DP', '树形DP', '插头DP'];
    const tag4 = ['搜索', 'DFS', 'BFS', '剪枝', '记忆化搜索', '迭代加深', '模拟退火', '爬山法'];
    const tag5 = ['数学', '博弈论', '矩阵', 'GCD', '线性筛', '欧拉筛'];
    const tag6 = ['图论', 'Kruskal', '网络流', '拓扑排序', "Dijkstra", '最短路', 'spfa', 'bellman-ford', '强连通分量', '双连通分量', '二分图',
                '最小割', 'Tarjin', '生成树', '最小环', 'Lca'];
    const tag7 = ['凸包', '叉积', '半平面交', '旋转卡壳'];
    export default {
        name:'question',
        components: {
            
        },
        data() {
            return {
                pbfrom: '1', // 表示默认是总题库
                select: [],
                tag0: tag0,
                tag1: tag1,
                tag2: tag2,
                tag3: tag3,
                tag4: tag4,
                tag5: tag5,
                tag6: tag6,
                tag7: tag7,
                dialogVisible: false, //打开算法标签用的
                loading: true,
                currentPage3: 1, // 默认位置页
                value:'', /* 难度选择 */
                Difficulity:[
                    {label:'简单', value:'简单'},
                    {label:'适中', value:'适中'},
                    {label:'困难', value:'困难'}
                ],
                options: [
                {
                    label: '基础',
                    options: [{
                        value: '分支',
                        label: '分支'
                    }, {
                        value: '循环',
                        label: '循环'
                    }, {
                        value: '字符串',
                        label: '字符串'
                    }, {
                        value: '数组',
                        label: '数组'
                    }, {
                        value: '指针',
                        label: '指针'
                    }]
                }, 
                {
                    label: '算法与数据机构',
                    options: [{
                        value: '高精度',
                        label: '高精度'
                    }, {
                        value: '二分',
                        label: '二分'
                    }, {
                        value: '图论',
                        label: '图论'
                    }, {
                        value: '搜索',
                        label: '搜索'
                    }, {
                        value: '贪心',
                        label: '贪心'
                    }, {
                        value: 'DP',
                        label: 'DP'
                    }]
                },
                {
                    label: '数论',
                    options: [{
                        value: 'Chengdu',
                        label: 'gcd'
                    }, {
                        value: 'Shenzhen',
                        label: ''
                    }, {
                        value: 'Guangzhou',
                        label: '广州'
                    }, {
                        value: 'Dalian',
                        label: '大连'
                    }]
                }
                ],
                IsVis:true,
                input: '', // 搜索
                showpage:[],
                Topic: [],

                pageSize: 1
            }
        },
        watch: {
            select: {
                deep:true,
                handler(value) {
                    console.log("new select == >", value)
                    this.$store.dispatch("problem/SelectQuestionList", {
                        list: value,
                        option: this.value,
                        input: this.input,
                        pbfrom: this.pbfrom,
                    })

                    // 立马刷新题库
                    this.loading = true
                    this.currentPage3 = 1
                    setTimeout(() => {
                        const Topic = this.$store.state.problem.question // 得到所有题库
                        this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                        this.loading = false;
                    }, 500)

                    // if (this.$store.state.problem.question.length !== 0) {
                    //     const Topic = this.$store.state.problem.question // 得到所有题库
                    //     this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                    //     this.loading = false
                    // }
                    // else {
                    //     const t = setInterval(() => {
                    //       if (this.$store.state.problem.question.length !== 0) {
                    //           console.log("我开始hh协议了")
                    //           const Topic = this.$store.state.problem.question // 得到所有题库
                    //           this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                    //           this.loading = false
                    //           clearInterval(t); // 清除定时器
                    //           console.log("我停止了")
                    //       }
                    //     }, 100);
                    // }
                }
            },
            pbfrom: {
                deep:true,
                handler(value) {
                    console.log("new pbfrom == >", value)
                    this.$store.dispatch("problem/SelectQuestionList", {
                        list: this.select,
                        option: this.value,
                        input: this.input,
                        pbfrom: value,
                    })

                    // 立马刷新题库
                    this.loading = true
                    this.currentPage3 = 1
                    setTimeout(() => {
                        const Topic = this.$store.state.problem.question // 得到所有题库
                        this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                        this.loading = false;
                    }, 500)
                }
            },
            value: {
                deep:true,
                handler(value) {
                    console.log("new value == > ", value)
                    this.$store.dispatch("problem/SelectQuestionList", {
                        list: this.select,
                        option: value,
                        input: this.input,
                        pbfrom: this.pbfrom,
                    })

                    // 立马刷新题库
                    this.loading = true
                    this.currentPage3 = 1
                    setTimeout(() => {
                        const Topic = this.$store.state.problem.question // 得到所有题库
                        this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                        this.loading = false;
                    }, 500)
                }
            },
            input: { // 因为这个是输入的 所以不能每输入一下就改一下 这里的请求要去掉 改成函数形式
                deep:true,
                handler(value) {
                    console.log("new input == > ", value)
                }
            }
        },
        mounted() {
            this.$store.dispatch("problem/GetQuestionList")

            if (this.$store.state.problem.question.length !== 0) {
                const Topic = this.$store.state.problem.question // 得到所有题库
                const s = (this.$store.state.problem.question.length) / 30 // 找到自己想要的页数
                this.pageSize = 1000 / s;
                this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                this.loading = false;
            }
            else {
                const t = setInterval(() => {
                    if (this.$store.state.problem.question.length !== 0) {
                        const Topic = this.$store.state.problem.question // 得到所有题库
                        const s = (this.$store.state.problem.question.length) / 30 // 找到自己想要的页数
                        this.pageSize = 1000 / s;
                        this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                        this.loading = false;
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            ClickMeToSearch() {
                console.log("我到这里了")
                this.$store.dispatch("problem/SelectQuestionList", {
                    list: this.select,
                    option: this.value,
                    input: this.input,
                    pbfrom: this.pbfrom,
                })

                // 立马刷新题库
                this.loading = true
                setTimeout(() => {
                    const Topic = this.$store.state.problem.question // 得到所有题库
                    this.showpage = Topic.slice(0, Math.min(30, Topic.length)) // 取出对应的30个
                    this.loading = false;
                }, 500)
            },
            ClickMeToClear() { // 把所有条件都给清空
                this.select = this.select.filter((value) => {
                    return value === ''
                })
                this.value = ''
                this.input = ''
            },
            ClickMeBySelect(item) { // 把select的item给删除掉
                this.select = this.select.filter((value) => {
                    return value !== item
                })
            },
            ClickMeToOpen() {
                this.dialogVisible = true
            },
            ClickMeToSelect() { // 用来给后端传筛选条件的
                this.dialogVisible = false
            },
            /* 实现编程式路由新开页面 */
            ClickMeGoproblem(t) {
                let routeData = this.$router.resolve({
                    path:`/Problem/Content/${t.pbid}`,
                });
                window.open(routeData.href, '_blank');
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                const Topic = this.$store.state.problem.question
                this.loading = true // 换页的时候就加载一下
                setTimeout(() => { // 故意等半秒 保证数据一定能加载完
                    this.showpage.length = 0
                    this.showpage = Topic.slice((val - 1) * 30, Math.min(val * 30, Topic.length))
                    this.loading = false // 然后结束加载
                }, 500);
                console.log(this.showpage.length)
            }
        }
    }
</script>

<style scoped>
.body-in-head {
    width: 1150px; 
    min-height: 32.8px; 
    height: auto; 
    display: flex; 
    float: left; 
    border-bottom: 2px solid #E8E8E8;
}
.body-in-body {
    min-height: 32.8px; 
    height: auto; 
    align-items:center; /* 这俩实现文字自动居中 */
    display: -webkit-flex; 
    font-size: 16px;
}
.body {
    border: 1px solid lightgrey;
    width: 1180px;
    min-height:400px;
    height: auto;
    margin:0 auto;
    background-color: white;
    padding: 20.8px;
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0px 6px 6px rgba(8, 9, 9, 0.12), 0 0 6px rgba(0, 0, 0, .04);
}


/* ******************************************************** 我是分割线 **************************************************** */
.head-title {
    width: 1180px;
    min-height: 160px;
    height: auto;
    background-color: white;
    margin:20px auto 20px auto;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 8px 14px 14px rgba(2, 235, 251, 0.12), 0 0 6px rgba(0, 0, 0, .04);
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-radius: 5px;
}
.head-title-in-1 { 
    width: 95%;
    height: 26px;
    line-height: 26px;
    
}
.head-title-in-2 { 
    margin-top:15px;
    width: 95%;
    height: 40px;
    line-height: 40px;
    font-size:15px;
}
.head-title-in-3 { 
    margin-top:10px;
    width: 95%;
    height: 40px;
    line-height: 40px;
}

/* 下拉菜单的样式 */
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}
.el-icon-arrow-down {
    font-size: 12px;
}
.demonstration {
    display: block;
    color: #8492a6;
    font-size: 15px;
}
</style>